module.exports = __webpack_public_path__ + "static/media/farmdokMockAppleMobileApplicationDE.86f6f112.png";